var projectName = require("../constants/Common");
let footerText = `Copyright © 2019 ${
    projectName.PROJECT_NAME
} Inc. All rights reserved.`;
module.exports = {
    footerText: footerText
};
